export default [
  {
    name: 'logical',
    colors: ['#F7A13D', '#54ADFD', '#FE766C', '#112264', '#005BF7', '#FC0340'],
    stroke: '#21202E',
    background: '#F8F8F8',
    isPrimary: true,
    type: 'basic',
  },
  {
    name: '12bitRainbow', // source: https://iamkate.com/data/12-bit-rainbow/
    colors: ['#817', '#a35', '#c66', '#e94', '#ed0', '#9d5', '#4d8', '#2cb', '#0bc', '#09c', '#36b', '#639'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'lighthouse',
    colors: ['#FF0A39', '#11C3EF', '#117092', '#E7F6FE'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'darkSands',
    colors: ['#f2e9e4', '#c9ada7', '#9a8c98', '#4a4e69', '#22223b'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'indianSummer',
    colors: ['#3c2706', '#7A5649', '#CC3904', '#e5cf0a'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'summer',
    colors: ['#f5f02b', '#19AAD1'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'fadedRainbow',
    colors: ['#ef476f', '#f78c6b', '#ffd166', '#06d6a0', '#118ab2', '#073b4c'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'mellowGreen',
    colors: ['#c6dabf', '#88d498', '#1a936f', '#114b5f'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'sunsetBeach',
    colors: ['#ea7317', '#fec601', '#73bfb8', '#3da5d9', '#2364aa'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'justBlack',
    colors: ['#000', '#000'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'justWhite',
    colors: ['#FFF', '#FFF'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'greyhound',
    colors: ['#696969', '#696969', '#696969', '#00A6B5'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'almostBlack',
    colors: ['#202020', '#404040'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'blackWhite',
    colors: ['#FFF', '#000'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'fullRainbow',
    colors: [
      '#1B1334',
      '#262A4A',
      '#00545A',
      '#027350',
      '#08C383',
      '#AAD962',
      '#FBBF46',
      '#EF6A32',
      '#ED0445',
      '#A12A5E',
      '#710262',
      '#110141',
    ],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'pastel',
    colors: ['#F7884B', '#E87A7A', '#B8609A', '#8F64B0', '#7171C4', '#5381E3', '#41ADD4', '#5CB592'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'brightBeach',
    colors: ['#1873D3', '#1237A1', '#00017A', '#FFDE00', '#FFB900'],
    isPrimary: false,
    type: 'basic',
  },
  // colors from d3
  {
    name: 'paired',
    colors: [
      '#A6CEE3',
      '#1F78B4',
      '#B2DF8A',
      '#33A02C',
      '#FB9A99',
      '#E31A1C',
      '#FDBF6F',
      '#FF7F00',
      '#CAB2D6',
      '#6A3D9A',
      '#FFFF99',
      '#B15928',
    ],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'sand',
    colors: ['#FCE29C', '#FCD67A', '#F0B46C', '#D59262', '#B47457', '#81514B', '#4C3C45'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'natural',
    colors: ['#F5C41E', '#F3B607', '#EC8E1E', '#8D9655', '#3E7D58', '#13404E'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'sweet',
    colors: ['#10BBB1', '#398A9B', '#DF1260', '#9D246F', '#401469'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'westCoast',
    colors: ['#D9CCC0', '#F19D1A', '#DC306A', '#7E245A', '#398589', '#093578', '#0F1A5E'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'mountain',
    colors: ['#8BBDD3', '#5396BA', '#D55F32', '#8D0805'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'freshCut',
    colors: ['#00B7D0', '#51CBD5', '#BCE849', '#A0CA00'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'mintHoney',
    colors: ['#434635', '#526D51', '#A5B17F', '#F0BF20', '#5F2A00'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'fluor',
    colors: ['#beeb00', '#D7F654', '#D3E0EA', '#8FABC1', '#507089', '#2a465c'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'district2',
    colors: ['#2A2955', '#382855', '#762754', '#E12955', '#FC2956'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'lemonade',
    colors: ['#C51645', '#C3144C', '#D34C53', '#F0AA64', '#F7C265'],
    isPrimary: true,
    type: 'basic',
  },
  {
    name: 'soft',
    colors: ['#F2F5E7', '#EBDED1', '#E5B5B7', '#D68097', '#B06683', '#705771', '#294353', '#0B3039'],
    isPrimary: false,
    type: 'basic',
  },
  {
    name: 'donut',
    colors: ['#FFB7BC', '#FF5181', '#FFCF49', '#FFA43F', '#5CCAEF'],
    isPrimary: true,
    type: 'basic',
  },
];
